/**
 * Pure ts safe property accessor
 */
export const _safe = <T>(fn: () => T, fallback?: T): T => {
  try {
    const value = fn();
    return value === null || value === undefined ? fallback : value;
  } catch (e) {
    return fallback;
  }
};
